import { render } from "./ReceiveTimes.vue?vue&type=template&id=2a80e70e&scoped=true"
import script from "./ReceiveTimes.vue?vue&type=script&lang=js"
export * from "./ReceiveTimes.vue?vue&type=script&lang=js"

import "./ReceiveTimes.vue?vue&type=style&index=0&id=2a80e70e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a80e70e"]])

export default __exports__